import { Component, inject, OnInit, signal } from '@angular/core';
import { TopRequestStatusEnum, TopUpRequestService } from '../../../../services/top-up-request/top-up-request';
import { FormatService } from '../../../../services/format/format.service';
import { ImageService } from '../../../../services/image/image.service';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'gmo-top-up-requests',
  imports: [CurrencyPipe],
  templateUrl: './top-up-requests.html',
  styleUrl: './top-up-requests.scss',
})
export class TopUpRequests implements OnInit {

  TopRequestStatusEnum = TopRequestStatusEnum;

  statusTabFilters = signal<TopRequestStatusEnum>(TopRequestStatusEnum.All);
  allTopupRequests = signal<any[] | undefined>(undefined);

  processingItems = signal<string[]>([]);

  /** Services */
  private topUpRequestService = inject(TopUpRequestService);
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  /** Services - END */

  ngOnInit(): void {
    this.getTopupRequests();
  }

  getTopupRequests() {
    if (this.processingItems().length > 0) {
      return;
    }
    this.topUpRequestService.getTopupRequests(this.statusTabFilters()).subscribe((res: any) => {
      console.log('Topup requests:', res);
      this.allTopupRequests.set(res);
    }, (error) => {
      console.error(error);
    });
  }

  selectApproveStatus(filter: TopRequestStatusEnum) {
    this.statusTabFilters.set(filter);
    this.allTopupRequests.set(undefined);
    this.getTopupRequests();
  }

  approve(id: string) {
    this.processingItems.update(items => [...items, id]);
    this.topUpRequestService.approve(id).subscribe({
      next: statusChangeRes => {
        const { topupRequest } = statusChangeRes as { topupRequest: { status: TopRequestStatusEnum } };
        this.updateRequestStatus(id, topupRequest.status);
      },
      error: err => {
        console.warn('approve statusChangeErr', err);
      },
      complete: () => {
        this.processingItems.update(items => items.filter(item => item !== id));
      }
    })
  }

  decline(id: string) {
    this.processingItems.update(items => [...items, id]);
    this.topUpRequestService.decline(id).subscribe({
      next: statusChangeRes => {
        const { topupRequest } = statusChangeRes as { topupRequest: { status: TopRequestStatusEnum } };
        this.updateRequestStatus(id, topupRequest.status);
      },
      error: err => {
        console.warn('decline statusChangeErr', err);
      },
      complete: () => {
        this.processingItems.update(items => items.filter(item => item !== id));
      }
    })
  }

  private updateRequestStatus(id: string, status: TopRequestStatusEnum): void {
    this.allTopupRequests.update(requests =>
      requests ? requests.map(request =>
        request.id === id ? { ...request, status } : request
      ) : []
    );  
  }

  getApproveTabClass(filter: TopRequestStatusEnum) {
    return this.statusTabFilters() === filter
      ? 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200'
      : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }

  getPayoutAttemptStatus(payoutStatus: TopRequestStatusEnum) {
    return TopRequestStatusEnum[payoutStatus];
  }

  getStatusColour(payoutStatus: TopRequestStatusEnum) {
    switch (payoutStatus) {
      case TopRequestStatusEnum.Created:
        // return "bg-orange-500";
        return "text-orange-700 bg-orange-50 ring-orange-600/20 dark:bg-orange-900/30 dark:text-orange-400 dark:ring-orange-500/50";
      case TopRequestStatusEnum.Approved:
        return "text-green-700 bg-green-50 ring-green-600/20 dark:bg-green-900/30 dark:text-green-400 dark:ring-green-500/50";
      case TopRequestStatusEnum.Declined:
        return "text-red-700 bg-red-50 ring-red-600/20 dark:bg-red-900/30 dark:text-red-400 dark:ring-red-500/50";
      default:
        return "text-gray-700 bg-gray-50 ring-gray-600/20 dark:bg-gray-900/30 dark:text-gray-400 dark:ring-gray-500/50";
    }
  }
}
